import { render, staticRenderFns } from "./checkPROrderLabels.vue?vue&type=template&id=dad85168&scoped=true&"
import script from "./checkPROrderLabels.vue?vue&type=script&lang=js&"
export * from "./checkPROrderLabels.vue?vue&type=script&lang=js&"
import style0 from "./checkPROrderLabels.vue?vue&type=style&index=0&id=dad85168&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dad85168",
  null
  
)

component.options.__file = "checkPROrderLabels.vue"
export default component.exports